module.exports = __webpack_public_path__ + "static/media/A10.31b21e00.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A10.png
// module id = 866
// module chunks = 0